import React, { Component } from "react";
import { connect } from "react-redux";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";
import { Form, Field } from "react-final-form";
import InputText from "@components/Form/InputText";
import Alert from "@components/Alert";
import { submitContentEditorForm } from "@store/cms/actions";
import Loading from "@components/Loading";

const formItemTypes = [
  "checkboxInput",
  "radioGroup",
  "textareaInput",
  "submitInput",
  "textInput",
  "hiddenInput",
];

class FormBlock extends Component {
  constructor(props) {
    super(props);

    this.formReset = undefined;

    this.state = {
      isSending: false,
      isSent: false,
    };
  }

  handleFormSubmit = async (values) => {
    const { submitContentEditorForm } = this.props;

    this.setState({
      isSending: true,
    });

    const response = await submitContentEditorForm({
      formName: this.props.name,
      formUrl: this.props.formUrl,
      values: values,
    });

    if (response) {
      this.setState({
        isSending: false,
        isSent: true,
      });

      // TODO: Fixed after package update
      // https://github.com/final-form/final-form/issues/142
      setTimeout(this.formReset, 100);
    } else {
      this.setState({
        isSent: false,
        isSending: false,
      });
    }
  };

  getInitialValues = () => {
    const initialValues = {};

    this.props.children
      // Filter form items
      .filter((item) => formItemTypes.includes(item.type))
      // Filter elements which don't contain default values
      // or are not radio groups
      .filter(
        (formItem) => formItem.type === "radioGroup" || formItem.content.value
      )
      .forEach((formItem) => {
        // For radio groups, first radio input is default value
        if (formItem.type === "radioGroup" && formItem.blocks.length > 0) {
          return (initialValues[`${formItem.content.name}`] =
            formItem.blocks[0].content.label);
        }

        return (initialValues[`${formItem.content.name}`] =
          formItem.content.value);
      });

    return initialValues;
  };

  render() {
    const { name, children, formUrl } = this.props;
    const { isSent, isSending } = this.state;

    // TODO: THIS IS NOT RIGHT!
    // FUNCTIONALITY WILL BREAK IF GW SUBDOMAINS CHANGE!!!!!
    const isXHR = formUrl.includes("fenrir") || formUrl.includes("cerberus");

    // if (this.props.valid) {
    return (
      <div className="js-cms-form u-space-mt-10 u-space-mb-10">
        <Form
          onSubmit={this.handleFormSubmit}
          initialValues={this.getInitialValues()}
          render={({ form, handleSubmit }) => {
            this.formReset = form.reset;

            return (
              <form
                {...(isXHR && { onSubmit: handleSubmit })}
                {...(!isXHR && { method: "post", action: formUrl })}
              >
                <Field
                  component={InputText}
                  id={name}
                  name={name}
                  type="hidden"
                />

                {children && <ContentEditorComponent content={children} />}
              </form>
            );
          }}
        />

        {isSending && <Loading height={80}>{`Se trimite`}</Loading>}

        {isSent && (
          <div className="u-space-mb-20 u-text-align-center">
            <Alert type="success" showIcon>
              Formularul a fost trimis.
            </Alert>
          </div>
        )}
      </div>
    );
    // }

    // // Invalid component
    // return null;
  }
}

export default connect(null, {
  submitContentEditorForm,
})(FormBlock);
